import { addDaysYMDLocal } from "../utils/dateUtils";

export function buildProgressDates({ dates, displayToday, exerciseLog, minimumDates = 5, maxDates = 8 }) {
  const candidateDates = Array.from(
    new Set([...(dates || []), ...Object.keys(exerciseLog || {})])
  );

  const historyDates = candidateDates
    .filter((date) => {
      if (date === displayToday) {
        return false;
      }

      const dayLog = exerciseLog?.[date];
      return dayLog && Object.keys(dayLog).length > 0;
    })
    .sort((a, b) => new Date(b) - new Date(a));

  const visibleDates = [displayToday, ...historyDates.slice(0, Math.max(0, maxDates - 1))];
  let back = 1;

  while (visibleDates.length < minimumDates) {
    const fallbackDate = addDaysYMDLocal(displayToday, -back);
    if (!visibleDates.includes(fallbackDate)) {
      visibleDates.push(fallbackDate);
    }
    back += 1;
  }

  return visibleDates.sort((a, b) => new Date(b) - new Date(a));
}
